import React from 'react';
import LegalLayout from '../components/LegalLayout';

const LegalNotice = () => {
  return (
    <LegalLayout 
      title="Mentions Légales et Avis de Non-Responsabilité"
      lastUpdated="26 février 2025"
    >
      <div className="space-y-8">
        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            Statut de l'exploitant
          </h2>
          <div className="bg-blue-50/50 p-6 rounded-xl border border-blue-100 space-y-4">
            <p className="text-gray-600">
              <span className="font-medium text-gray-800">Entrepreneur individuel en voie d'immatriculation</span> : Clicdroits.info est exploité par{' '}
              <span className="font-medium text-gray-800">M. Abderauf Kakhlaui</span>, qui prévoit d'immatriculer son entreprise au Québec d'ici <span className="font-medium">septembre 2025</span>, conformément à la Loi sur la publicité légale des entreprises.
            </p>
            <p className="text-gray-600">
              <span className="font-medium text-gray-800">Service actuel et évolution future</span> : Présentement, Clicdroits.info est proposé comme ressource d'information juridique <strong>gratuite</strong>. L'immatriculation envisagée pour septembre 2025 accompagnera le déploiement d'un service complémentaire à valeur ajoutée qui pourrait inclure des fonctionnalités payantes. L'accès gratuit aux renseignements de base demeurera cependant garanti.
            </p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            Objet du service
          </h2>
          <div className="space-y-4">
            <div className="bg-blue-50/50 p-6 rounded-xl border border-blue-100">
              <p className="text-gray-600">
                <span className="font-medium text-gray-800">Informations juridiques générales</span> : Le Site fournit des informations d'ordre général 
                et des estimations, mais ne constitue pas un cabinet d'avocats, ni un service d'assistance juridique personnalisé.
              </p>
            </div>
            
            <div className="bg-blue-50/50 p-6 rounded-xl border border-blue-100">
              <p className="text-gray-600">
                <span className="font-medium text-gray-800">Aucun mandat de représentation</span> : Utiliser Clicdroits.info ne crée pas de relation avocat-client. 
                Pour un guide professionnel, consultez un avocat dûment inscrit à un Barreau compétent.
              </p>
            </div>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            Avis de non-responsabilité
          </h2>
          <div className="space-y-4">
            <div className="bg-blue-50/50 p-6 rounded-xl border border-blue-100">
              <p className="text-gray-600">
                <span className="font-medium text-gray-800">1. Exclusion de garantie</span> : Nous ne garantissons pas l'exactitude, l'exhaustivité ou la mise à jour 
                de l'information fournie, compte tenu de la complexité et l'évolution constante du cadre légal.
              </p>
            </div>
            
            <div className="bg-blue-50/50 p-6 rounded-xl border border-blue-100">
              <p className="text-gray-600">
                <span className="font-medium text-gray-800">2. Décisions de l'utilisateur</span> : Vous êtes seul responsable des décisions que vous prenez. 
                Les informations ou estimations obtenues sur le Site ne remplacent pas l'avis et l'expertise d'un professionnel du droit.
              </p>
            </div>
            
            <div className="bg-blue-50/50 p-6 rounded-xl border border-blue-100">
              <p className="text-gray-600">
                <span className="font-medium text-gray-800">3. Risques</span> : Votre utilisation des outils et contenus de Clicdroits.info se fait à vos propres risques.
              </p>
            </div>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            Propriété intellectuelle
          </h2>
          <div className="bg-blue-50/50 p-6 rounded-xl border border-blue-100">
            <p className="text-gray-600">
              <span className="font-medium text-gray-800">Contenus protégés</span> : Tous les contenus du Site (textes, images, marques, algorithmes, logos) 
              sont la propriété de M. Abderauf Kakhlaui ou de nos concédants de licence, lorsqu'applicable. 
              Toute reproduction, distribution ou utilisation à des fins non autorisées est interdite.
            </p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            Contact
          </h2>
          <div className="bg-blue-50/50 p-6 rounded-xl border border-blue-100">
            <p className="text-gray-600">
              <span className="font-medium text-gray-800">Courriel</span> : {' '}
              <a href="mailto:raouf@clicdroits.info" className="text-primary hover:text-primary/80 underline">
                raouf@clicdroits.info
              </a>
            </p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            Modifications
          </h2>
          <div className="bg-blue-50/50 p-6 rounded-xl border border-blue-100">
            <p className="text-gray-600">
              Ces Mentions légales et avis de non-responsabilité peuvent être mis à jour à tout moment. 
              Les changements prendront effet dès leur publication.
            </p>
          </div>
        </section>
      </div>
    </LegalLayout>
  );
};

export default LegalNotice;
